import { hot } from 'react-hot-loader/root';
import { setConfig } from 'react-hot-loader';
import App from '../app';

setConfig({
  errorReporter: error => {
    // Rethrow error so react-error-overlay can pick it up
    throw error.error;
  },
});

export default hot(App);
